// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ProductRecommendationBrandModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import {
    chain,
    PrepareData,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareBrand";
import { generateGeneralPrepare } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{ brandFacets: FacetModel[] }, { recommendation: ProductRecommendationBrandModel }>;

export const XngPrepareData: HandlerType = props => {
    const {
        getState,
        parameter: { brandFacets },
    } = props;

    const selectedBrand = brandFacets.find(o => o.selected);
    if (!selectedBrand) {
        return false;
    }

    props.recommendation = {
        type: "brand",
        // XNG-CHANGES
        brand: selectedBrand.name,
        ...generateGeneralPrepare(getState()),
    };
};
replaceInChain(chain, PrepareData, XngPrepareData);
